import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';


import '../Resources/dashboard.css';
import axios from '../../axios.js';
import Navbar from '../navbar';
import Sidebar from '../Sidebar';
import Create_salary from './create_salary';
import LineChart from '../components/Linechart.js';
import BarChart from '../components/Barchart.js';


import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

function Usersalary(){

  

 //Report Print Function
 const componentRef = useref();
 const handlePrint = useReactToPrint({
   content: () => componentRef.current,
 });
  
 
 // Function to download the data as an Excel file
 const downloadExcel = () => {
  // Convert JSON data to Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Create a new workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(excel_data, "salary_data.xlsx");
};


 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");

 /* PAGE VARIABLES */


 
{/* SALARY TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14
const[cd_col15_val,setcd_col15_val] = useState(0);//column15
const[cd_col16_val,setcd_col16_val] = useState(0);//column16
const[cd_col17_val,setcd_col17_val] = useState(0);//column17
const[cd_col18_val,setcd_col18_val] = useState(0);//column18
const[cd_col19_val,setcd_col19_val] = useState(0);//column19
const[cd_col20_val,setcd_col20_val] = useState(0);//column20
const[cd_col21_val,setcd_col21_val] = useState(0);//column21
const[cd_col22_val,setcd_col22_val] = useState(0);//column22
const[cd_col23_val,setcd_col23_val] = useState(0);//column23
const[cd_col24_val,setcd_col24_val] = useState(0);//column24

{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES END */}



 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/*if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{

   */}
  

 
 
//Variables
const[data,setData] = useState([]);//SetData Variable
const[Tbanks,setTbanks] = useState([]);//SetData Variable
const[eemployees,setemployees] = useState([],);//SetData Variable
const[ecdefault,setecdefault] = useState(0);


//Error Variable
const[errorvar,seterrorvar] = useState();
    
 

//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);
const[filter_employee_code,setfilter_employee_code] = useState(); const updatefilter_employee_code = (event) => { setfilter_employee_code(event.target.value);}; const[filter_employee_code_er,setfilter_employee_code_er]=useState();
const[filter_first_name,setfilter_first_name] = useState(); const updatefilter_first_name = (event) => { setfilter_first_name(event.target.value);}; const[filter_first_name_er,setfilter_first_name_er]=useState();
const[filter_last_name,setfilter_last_name] = useState(); const updatefilter_last_name = (event) => { setfilter_last_name(event.target.value); }; const[filter_last_name_er,setfilter_last_name_er]=useState();
const[filter_email,setfilter_email] = useState(); const updatefilter_email = (event) => { setfilter_email(event.target.value);}; const[filter_email_er,setfilter_email_er]=useState();
const[filter_contact,setfilter_contact] = useState(); const updatefilter_contact = (event) => { setfilter_contact(event.target.value);}; const[filter_contact_er,setfilter_contact_er]=useState();
const[filter_type,setfilter_type] = useState(); const updatefilter_type = (event) => { setfilter_type(event.target.value);}; const[filter_type_er,setfilter_type_er]=useState();
const[filter_amount,setfilter_amount] = useState(); const updatefilter_amount = (event) => { setfilter_amount(event.target.value);}; const[filter_amount_er,setfilter_amount_er]=useState();
const[filter_amount_sign,setfilter_amount_sign] = useState(); const updatefilter_amount_sign = (event) => { setfilter_amount_sign(event.target.value);}; const[filter_amount_sign_er,setfilter_amount_sign_er]=useState();
const[filter_mode,setfilter_mode] = useState(); const updatefilter_mode = (event) => { setfilter_mode(event.target.value);}; const[filter_mode_er,setfilter_mode_er]=useState();
const[filter_bank_id,setfilter_bank_id] = useState(); const updatefilter_bank_id = (event) => { setfilter_bank_id(event.target.value);}; const[filter_bank_id_er,setfilter_bank_id_er]=useState();
const[filter_salary_status,setfilter_salary_status] = useState(); const updatefilter_salary_status = (event) => { setfilter_salary_status(event.target.value);}; const[filter_salary_status_er,setfilter_salary_status_er]=useState();
const[filter_start_date,setfilter_start_date] = useState('1970-01-01'); const updatefilter_start_date = (event) => { setfilter_start_date(event.target.value);}; const[filter_start_date_er,setfilter_start_date_er]=useState();
const[filter_end_date,setfilter_end_date] = useState('2100-12-12'); const updatefilter_end_date = (event) => { setfilter_end_date(event.target.value);}; const[filter_end_date_er,setfilter_end_date_er]=useState();
const[filter_trno,setfilter_trno] = useState(); const updatefilter_trno = (event) => { setfilter_trno(event.target.value);}; const[filter_trno_er,setfilter_trno_er]=useState();


//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);
    
useEffect(()=>{
   
  getData();
  
  },[])




//******************* GET ASSETS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((busyid!=null)||(busyid!=" "))){
 
    //Fetching Filter Variables

   const $filter_employee_code = filter_employee_code; const $filter_first_name = filter_first_name; const $filter_last_name = filter_last_name; const $filter_email = filter_email; const $filter_contact = filter_contact;
   const $filter_type = filter_type; const $filter_amount = filter_amount; const $filter_mode = filter_mode; const $filter_bank_id = filter_bank_id; const $filter_salary_status = filter_salary_status; 
   const $filter_start_date = filter_start_date; const $filter_end_date = filter_end_date; const $filter_trno = filter_trno; const $filter_amount_sign = filter_amount_sign;

 axios.post("bt-get-salary", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
  
   //Filters
   Filter_val : filter_val,
   Filter_employee_code : $filter_employee_code,
   Filter_first_name : $filter_first_name,
   Filter_last_name : $filter_last_name,
   Filter_email : $filter_email,
   Filter_contact : $filter_contact,
   Filter_type : $filter_type,
   Filter_amount : $filter_amount,
   Filter_amount_sign : $filter_amount_sign,
   Filter_mode : $filter_mode,
   Filter_bank_id : $filter_bank_id,
   Filter_salary_status : $filter_salary_status,
   Filter_start_date : moment($filter_start_date).format('YYYY-MM-DD'),
   Filter_end_date : moment($filter_end_date).format('YYYY-MM-DD'),
   Filter_trno : $filter_trno,

  
//Code Edits for pagination
'page' : pageNumber




 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
     return;
  }
  //Success Data Fetched
  if(response.data.successvar==1){

   

   //Setting Data
   setData(response.data.data.data);
   setTbanks(response.data.bank_data);
 
 

  }
   //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){

    setfilter_employee_code_er(response.data.validatorerror.Filter_employee_code);
    setfilter_first_name_er(response.data.validatorerror.Filter_first_name);
    setfilter_last_name_er(response.data.validatorerror.Filter_last_name);
    setfilter_email_er(response.data.validatorerror.Filter_email);
    setfilter_contact_er(response.data.validatorerror.Filter_contact);
    setfilter_type_er(response.data.validatorerror.Filter_type);
    setfilter_mode_er(response.data.validatorerror.Filter_mode);
    setfilter_amount_er(response.data.validatorerror.Filter_amount);
    setfilter_amount_sign_er(response.data.validatorerror.Filter_amount_sign);
    setfilter_bank_id_er(response.data.validatorerror.Filter_bank_id);
    setfilter_salary_status_er(response.data.validatorerror.Filter_salary_status);
    setfilter_start_date_er(response.data.validatorerror.Filter_start_date);
    setfilter_end_date_er(response.data.validatorerror.Filter_end_date);
    setfilter_trno_er(response.data.validatorerror.Filter_trno);

  

  }

  //Data Violation
  if(response.data.error==102){ 
  
    setfilter_employee_code_er(response.data.filter_employee_code_er);
    setfilter_first_name_er(response.data.filter_first_name_er);
    setfilter_last_name_er(response.data.filter_last_name_er);
    setfilter_email_er(response.data.filter_email_er);
    setfilter_contact_er(response.data.filter_contact_er);
    setfilter_type_er(response.data.filter_type_er);
    setfilter_mode_er(response.data.filter_mode_er);
    setfilter_amount_er(response.data.filter_amount_er);
    setfilter_amount_sign_er(response.data.filter_amount_sign_er);
    setfilter_bank_id_er(response.data.filter_bank_id_er);
    setfilter_salary_status_er(response.data.filter_salary_status_er);
    setfilter_start_date_er(response.data.filter_start_date_er);
    setfilter_end_date_er(response.data.filter_end_date_er);
    setfilter_trno_er(response.data.filter_trno_er);
   



  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }


 
//******************* DELETE SALARY FUNCTION START ********************//
function deletesalary(){

  const editId=sessionStorage.getItem("DEditId00");
  const trno=sessionStorage.getItem("DTrno00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((busyid!=null)||(busyid!=" "))&&((counterid!=null)||(counterid!=" "))&&((editId!=null)||(editId!=" "))){
 
 axios.post("bt-salary-delete", {
   Busy_id:busyid,
   Counter_id:counterid,
   Log_id:logid,
   Token:token,
   Edit_id:editId,
   Tr_no:trno
 })
 .then((response) => {

  //console.log(response);

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("DEditId");
     sessionStorage.removeItem("DTrno00");

     window.location.replace("businesstools-login");
  }

  //Counter Deleted Successfully
   if(response.data.successvar==1){        

      document.getElementById("delete-card").style.display="none";
      document.getElementById("delete-success-card").style.display="block";  
      sessionStorage.removeItem("DEditId");
      sessionStorage.removeItem("DTrno00");

  }
  
      //Cannot Delete Counter
    else{  
    document.getElementById("delete-card").style.display="none";
    document.getElementById("delete-error-card").style.display="block";   }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   sessionStorage.removeItem("DEditId00");
   sessionStorage.removeItem("DTrno00");


   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* DELETE SALARY FUNCTION END ********************//


  
 //******************* GET ASSETS DATA FUNCTION END  ********************//


 /* PAGINATION */
 /*const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

const renderPaginationButtons = () => {
  const { current_page, last_page } = cashbookEntries.meta;
  const previousButtonDisabled = current_page === 1;
  const nextButtonDisabled = current_page === last_page;
}
*/




 //SETTING DATA VARIABLES
 const[eemployee_id,seteemployee_id]=useState();const updateeemployee_id = (event) => { seteemployee_id(event.target.value);}; const[eemployee_id_er,seteemployee_id_er]=useState();
 const[eemployee_code,seteemployee_code]=useState();const updateeemployee_code = (event) => { seteemployee_code(event.target.value);}; const[eemployee_code_er,seteemployee_code_er]=useState();
 const[efirst_name,setefirst_name]=useState();const updateefirst_name = (event) => { setefirst_name(event.target.value); geteemployeebyname(); }; const[efirst_name_er,setefirst_name_er]=useState();
 const[elast_name,setelast_name]=useState();const updateelast_name = (event) => { setelast_name(event.target.value);}; const[elast_name_er,setelast_name_er]=useState();
 const[eemail,seteemail]=useState();const updateeemail = (event) => { seteemail(event.target.value);}; const[eemail_er,seteemail_er]=useState();
 const[econtact,setecontact]=useState();const updateecontact = (event) => { setecontact(event.target.value);}; const[econtact_er,setecontact_er]=useState();
 const[edate,setedate]=useState();const updateedate = (event) => { setedate(event.target.value);}; const[edate_er,setedate_er]=useState();
 const[etype,setetype]=useState();const updateetype = (event) => { setetype(event.target.value);}; const[etype_er,setetype_er]=useState();
 const[ebasic_salary,setebasic_salary]=useState();const updateebasic_salary = (event) => { setebasic_salary(event.target.value);}; const[ebasic_salary_er,setebasic_salary_er]=useState();
 const[eincentives,seteincentives]=useState();const updateeincentives = (event) => { seteincentives(event.target.value);}; const[eincentives_er,seteincentives_er]=useState();
 const[eallowances,seteallowances]=useState();const updateeallowances = (event) => { seteallowances(event.target.value);}; const[eallowances_er,seteallowances_er]=useState();
 const[eprovident_fund,seteprovident_fund]=useState();const updateeprovident_fund = (event) => { seteprovident_fund(event.target.value);}; const[eprovident_fund_er,seteprovident_fund_er]=useState();
 const[esalary_deductions,setesalary_deductions]=useState();const updateesalary_deductions = (event) => { setesalary_deductions(event.target.value);}; const[esalary_deductions_er,setesalary_deductions_er]=useState();
 const[eamount,seteamount]=useState();const updateeamount = (event) => { seteamount(event.target.value);}; const[eamount_er,seteamount_er]=useState();
 const[emode,setemode]=useState();const updateemode = (event) => { setemode(event.target.value);}; const[emode_er,setemode_er]=useState();
 const[ebank_id,setebank_id]=useState();const updateebank_id = (event) => { setebank_id(event.target.value);}; const[ebank_id_er,setebank_id_er]=useState();
 const[ebank_name,setebank_name]=useState();const updateebank_name = (event) => { setebank_name(event.target.value);}; const[ebank_name_er,setebank_name_er]=useState();
 const[esalary_status,setesalary_status]=useState();const updateesalary_status = (event) => { setesalary_status(event.target.value);}; const[esalary_status_er,setesalary_status_er]=useState();
 const[esalary_remarks,setesalary_remarks]=useState();const updateesalary_remarks = (event) => { setesalary_remarks(event.target.value);}; const[esalary_remarks_er,setesalary_remarks_er]=useState();

//ERROR VARIABLES 
//const[eerror_msg,seteerror_msg]=useState();
const[eerror_msg,seteerror_msg]=useState();


//******************* EDIT SALARY FUNCTION START ********************//
function editsalary(){

  const editId=sessionStorage.getItem("EditId00");
  const trno=sessionStorage.getItem("Trno00");

  //Setting Error Variables
  seteemployee_id_er(" ");seteemployee_code_er(" ");setefirst_name_er(" ");setelast_name_er(" ");seteemail_er(" ");setecontact_er(" ");setedate_er(" ");setemode_er(" ");setebank_id_er(" ");setetype_er(" ");
  setebasic_salary_er(" ");seteincentives_er(" ");seteallowances_er(" ");seteprovident_fund_er(" ");setesalary_deductions_er(" ");seteamount_er(" ");setesalary_status_er(" ");setesalary_remarks_er(" ");seteerror_msg(" ");


  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((busyid!=null)||(busyid!=" "))&&((counterid!=null)||(counterid!=" "))&&((editId!=null)||(editId!=" "))){
 
 
  axios.post("bt-salary-edit", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Employee_id:eemployee_id,
   Employee_code:eemployee_code,
   First_name:efirst_name,
   Last_name:elast_name,
   Email:eemail,
   Contact:econtact,
   Type:etype,
   Date:moment(edate).format('YYYY-MM-DD'),
   Mode:emode,
   Bank_id:ebank_id,
   Basic_salary:ebasic_salary,
   Incentives:eincentives,
   Allowances:eallowances,
   Provident_fund:eprovident_fund,
   Salary_deductions:esalary_deductions,
   Amount:eamount,
   Salary_status:esalary_status,
   Salary_remarks:esalary_remarks,
   Edit_id:editId,
   Tr_no:trno


  })
  .then((response) => {

    console.log(response);

  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("EditId00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
 else if(response.data.validatorerror){
  seteemployee_id_er(response.data.validatorerror.Employee_id);
  seteemployee_code_er(response.data.validatorerror.Employee_code);
  setefirst_name_er(response.data.validatorerror.First_name);
  setelast_name_er(response.data.validatorerror.Last_name);
  setecontact_er(response.data.validatorerror.Contact);
  seteemail_er(response.data.validatorerror.Email);
  setetype_er(response.data.validatorerror.Type);
  setedate_er(response.data.validatorerror.Date);
  setebasic_salary_er(response.data.validatorerror.Basic_salary);
  seteincentives_er(response.data.validatorerror.Incentives);
  seteallowances_er(response.data.validatorerror.Allowances);
  seteprovident_fund_er(response.data.validatorerror.Provident_fund);
  setesalary_deductions_er(response.data.validatorerror.Salary_deductions);
  seteamount_er(response.data.validatorerror.Amount);
  setemode_er(response.data.validatorerror.Mode);
  setebank_id_er(response.data.validatorerror.Bank_id);
  setesalary_status_er(response.data.validatorerror.Salary_status);
  setesalary_remarks_er(response.data.validatorerror.Salary_remarks);
  seteerror_msg("Cannot Update Transaction !");

}
//Invalid Entries
else if(response.data.error==102){ 
  
  seteemployee_id_er(response.data.employee_id_er);
  seteemployee_code_er(response.data.employee_code_er);
  setefirst_name_er(response.data.first_name_er);
  setelast_name_er(response.data.last_name_er);
  setecontact_er(response.data.contact_er);
  seteemail_er(response.data.email_er);
  setetype_er(response.data.type_er);
  setedate_er(response.data.date_er);
  setebasic_salary_er(response.data.basic_salary_er);
  seteincentives_er(response.data.incentives_er);
  seteallowances_er(response.data.allowances_er);
  seteprovident_fund_er(response.data.provident_fund_er);
  setesalary_deductions_er(response.data.salary_deductions_er);
  seteamount_er(response.data.amount_er);
  setemode_er(response.data.mode_er);
  setebank_id_er(response.data.bank_id_er);
  setesalary_status_er(response.data.salary_status_er);
  setesalary_remarks_er(response.data.salary_remarks_er);
  seteerror_msg("Cannot Update Transaction !");  
}


  //Invalid Entries
  else if(response.data.error==103){     seteerror_msg(response.data.error_msg);  }

   //Bank Updated Successfully
   else if(response.data.successvar==1){        

    document.getElementById("edit-form").style.display="none";  
    seteemployee_id_er(" ");seteemployee_code_er(" ");setefirst_name_er(" ");setelast_name_er(" ");seteemail_er(" ");setecontact_er(" ");setedate_er(" ");setemode_er(" ");setebank_id_er(" ");setetype_er(" ");
    setebasic_salary_er(" ");seteincentives_er(" ");seteallowances_er(" ");seteprovident_fund_er(" ");setesalary_deductions_er(" ");seteamount_er(" ");setesalary_status_er(" ");setesalary_remarks_er(" ");seteerror_msg(" ");
    //
    seteemployee_id(" ");seteemployee_code(" ");setefirst_name(" ");setelast_name(" ");seteemail(" ");setecontact(" ");setedate(" ");setemode(" ");setebank_id(" ");setetype(" ");
    setebasic_salary(" ");seteincentives(" ");seteallowances(" ");seteprovident_fund(" ");setesalary_deductions(" ");seteamount(" ");setesalary_status(" ");setesalary_remarks(" ");
      
    document.getElementById("edit-success-card").style.display="block";  }
   //Cannot AUpdate Bank
   else{  seteerror_msg("Cannot Edit Transaction!"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* EDIT SALARY FUNCTION END ********************//


    

  
//******************* GET EMPLOYEE DATA BY NAME FUNCTION START  ********************//
function geteemployeebyname(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((busyid!=null)||(busyid!=" "))){
 
     const cname = document.getElementById("efirst_name").value;
     const cnlength = cname.length;
     if((ecdefault==0)&&(cnlength>=3)){
     
 
 axios.post("bt-get-employee-details-by-name", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Name:document.getElementById("efirst_name").value,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0
 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setemployees(response.data.employeelist);
   document.getElementById("edit-employees-list-box").style.display="block";
  
  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
}
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }

 }
  
 //******************* GET EMPLOYEE DATA BY NAME FUNCTION END  ********************//

 



return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Business Tools|BookKeeping Solution</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

          {/* SUCCESS CARD START */}
          <div className="d-flex justify-content-center">
          <div className="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title  text-success">New Transaction Added Successfully !!!</h4>
                  
                    <blockquote className="blockquote">
                      <p className="mb-0"> Click the following button to close.</p>
                      <a href="businesstools-user-salary"><button className="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* SUCCESS CARD END */}
     
               {/* ADD SALARY EDIT SUCCESS CARD START */}
               <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Transaction Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-success-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD SALARY EDIT SUCCESS CARD END */}
               {/* ADD SALARY EDIT ERROR CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-error-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Cannot Fetch Data !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-error-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD SALARY EDIT ERROR CARD END */}


                   {/* DELETE CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Are you sure you want to delete this transaction, you will loss all transaction data ?</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> This action cannot be reversed. You will lose all your data related to this transaction if you wish to continue this action.</p>
                      <button class="mt-3 btn btn-outline-success" onClick={deletesalary}>Yes, I Know! Delete Transaction.</button>
                      <button class="mt-3 btn btn-outline-danger" style={{marginLeft:"1rem"}} onClick={()=>{  
                      //Cancel Delete and remove Edit_id
                      sessionStorage.removeItem("DEditId00");  
                      sessionStorage.removeItem("DTrno00"); 
                      document.getElementById('delete-card').style.display = 'none'; }}>No, Don't Delete Transaction.</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* DELETE CARD END */}
              {/* DELETE SUCCESS CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Transaction Deleted Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("delete-success-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* DELETE SUCCESS CARD END */}
               {/*  DELETE ERROR CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-error-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Cannot Delete Transaction !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("delete-error-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* DELETE ERROR CARD END */}




          <div className="content-wrapper pb-0">

          <div className="row">
              <div className="col-12 grid-margin create-form" id="create-form">
              <Create_salary /> 
              </div>
          </div>


            <div className="page-header flex-wrap">
            <div className="header-left"></div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">SALARY MANAGEMENT</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                  {/*}  <p className="m-0">ADE-00234</p> */}
                  </a>
                </div>
                <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text"  onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i className="mdi mdi-plus-circle"></i> Manage Salary </button>
              </div>
            </div>


                      {/* EMPLOYEES LIST BOX START */}
                      <div class="d-flex justify-content-center">
          <div class="col-md-4 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"1rem",display:"none"}} id="edit-employees-list-box">
                <div class="card">
                <div class="d-flex justify-content-between">
                    <div>
                    <h4 style={{padding:'1rem'}}>Employees</h4>
                    </div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ setecdefault(1); document.getElementById("edit-employees-list-box").style.display="none"; }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                    
                    <table class="table table-hover">
                      <thead>
                        <tr>
                         {/*} <th>employee Id</th> */}
                          <th>Name</th>
                         {/*} <th>Email</th> */}
                          <th>Contact</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                       eemployees.map((curElm6,ind)=>{

                         return(
                         <>
                        <tr key={curElm6.Id}>
                          {/* <td>{curElm6.employee_id}</td> */}
                          <td>{curElm6.First_name} {curElm6.Last_name}</td>
                         {/*} <td>{curElm6.Email}</td> */}
                          <td>{curElm6.Contact}</td>
                          <td><i class="mdi mdi-assistant text-warning" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                        //Setting employee Details for 
                        setefirst_name(curElm6.First_name); setelast_name(curElm6.Last_name);seteemployee_id(curElm6.Id); seteemployee_code(curElm6.Employee_code);setecontact(curElm6.Contact);seteemail(curElm6.Email);
                        setebasic_salary(curElm6.Basic_salary); seteincentives(curElm6.Incentives); seteallowances(curElm6.Allowances); seteprovident_fund(curElm6.Provident_fund); setesalary_deductions(curElm6.Salary_deductions); seteamount(curElm6.Monthly_salary);
                        document.getElementById("edit-employees-list-box").style.display="none";
                              }}></i></td>

                        </tr>
                        </>
                         )
                         }
					   
	                  		 )
                         }
                      </tbody>
                    </table>
              
                </div>
              </div>
              </div>
              {/* EMPLOYEES LIST BOX END */}

             {/* EDIT SALARY FORM START */}
          <div class="row">
              <div class="col-12 grid-margin create-form" id="edit-form" style={{display:"none"}}>
              <div class="card" style={{textAlign:"left"}}>
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ 
                        //Removing Sessions and Closing Add Bank Edit
                        document.getElementById("edit-form").style.display="none";  

                        seteemployee_id_er(" ");seteemployee_code_er(" ");setefirst_name_er(" ");setelast_name_er(" ");seteemail_er(" ");setecontact_er(" ");setedate_er(" ");setemode_er(" ");setebank_id_er(" ");setetype_er(" ");
                        setebasic_salary_er(" ");seteincentives_er(" ");seteallowances_er(" ");seteprovident_fund_er(" ");setesalary_deductions_er(" ");seteamount_er(" ");setesalary_status_er(" ");setesalary_remarks_er(" ");seteerror_msg(" ");
                        //
                        seteemployee_id(" ");seteemployee_code(" ");setefirst_name(" ");setelast_name(" ");seteemail(" ");setecontact(" ");setedate(" ");setemode(" ");setebank_id(" ");setetype(" ");
                        setebasic_salary(" ");seteincentives(" ");seteallowances(" ");seteprovident_fund(" ");setesalary_deductions(" ");seteamount(" ");setesalary_status(" ");setesalary_remarks(" ");
      

                        document.getElementById("edit-form").style.display="none";
                        sessionStorage.removeItem("EditId00");
                        sessionStorage.removeItem("Trno00");
                        
                         }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Edit Employee</h4>
                    <div class="form-sample">
                      <p class="card-description">edit employee details</p>
                      <code>{eerror_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Date</label>
                            <div class="col-sm-9">
                            <input type="edate" class="form-control" placeholder="" id="edate" value={edate} onChange={updateedate} />
                            <code>{edate_er}</code>
                            </div>
                          </div>
                        </div> 
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="Type" id="etype" value={etype} onChange={updateetype} />
                            <code>{etype_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">First Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="First Name" id="efirst_name" value={efirst_name} onChange={updateefirst_name} />
                              <code>{efirst_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Last Name</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="Last Name" id="elast_name" value={elast_name} onChange={updateelast_name}  />
                            <code>{elast_name_er}</code>
                            </div>
                          </div>
                        </div>   
                        </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Employee Id</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="0001" id="eemployee_id" value={eemployee_id} onChange={updateeemployee_id} />
                              <code>{eemployee_id_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Employee_code</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="EMP0001" id="eemployee_code" value={eemployee_code} onChange={updateeemployee_code} />
                              <code>{eemployee_code_er}</code>
                            </div>
                          </div>
                        </div>  
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="myemail@gmail.com"  id="eemail" value={eemail} onChange={updateeemail} />
                              <code>{eemail_er}</code> 
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="91 9000000000"  id="econtact" value={econtact} onChange={updateecontact} />
                              <code>{econtact_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <hr/>
                      <h4>Salary Details</h4>
                   
                      <div class="row mt-3">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Salary Status</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="esalary_status" value={esalary_status} onChange={updateesalary_status}>
                            <option value=" ">select salary status</option>
                            <option value="payment">payment</option>
                            <option value="due">due</option>
                            <option value="advance">advance</option>
                            </select>
                            <code>{esalary_status_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Basic Salary</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="10000.00" id="ebasic_salary" value={ebasic_salary} onChange={updateebasic_salary} />
                            <code>{ebasic_salary_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row" hidden={esalary_status=="due"}>
                      <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Mode</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="emode" value={emode} onChange={updateemode} >
                            <option value=" ">select mode</option>
                            <option value="cash">cash</option>
                            <option value="bank">bank</option>
                            </select>
                            <code>{emode_er}</code>
                            </div>
                          </div>
                        </div>     
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Select Bank</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Select Bank" style={{padding:"1rem"}} id="ebank_id" value={ebank_id} onChange={updateebank_id}>
                              <option value="">Select Bank</option>
                              {
                              Tbanks.map((curElm2,ind)=>{

                              return(
                              <>
                              <option value={curElm2.Bank_id}>{curElm2.Bank_name}</option>
                              </>
                              )
                              }
	 				   
	                         		)
                              }
                              </select>
                              <code>{ebank_id_er}</code>
                            </div>
                          </div>
                        </div>                 
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Incentives</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="10000.00" id="eincentives" value={eincentives} onChange={updateeincentives} />
                              <code>{eincentives_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Allowances</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="5000.00" id="eallowances" value={eallowances} onChange={updateeallowances} />
                            <code>{eallowances_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Provident Fund</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="500.00" id="eprovident_fund" value={eprovident_fund} onChange={updateeprovident_fund} />
                              <code>{eprovident_fund_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Salary Deductions</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="500.00" id="esalary_deductions" value={esalary_deductions} onChange={updateesalary_deductions} />
                            <code>{esalary_deductions_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="1000.00" id="eamount" value={eamount} onChange={updateeamount} />
                              <code>{eamount_er}</code>
                            </div>
                          </div>
                        </div>
                                       
                      </div>
                   
                      <div class="form-group">
                        <label for="exampleTextarea1">Remarks</label>
                        <textarea  class="form-control" rows="2" placeholder="Add your Remarks here" id="esalary_remarks" value={esalary_remarks} onChange={updateesalary_remarks} />
                        <code>{esalary_remarks_er}</code>
                      </div>

                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={editsalary}>Edit Salary</button>
                      
                   
                    </div>
                  </div>
                </div>
              </div>
          </div>
          {/* EDIT SALARY FORM END */}




              {/* CASH TRANSACTIONS TABLE SECTION START */}
                  
             <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Manage Salaries</h4>
                    <p className="card-description">manage your salaries from here
                    </p>

                           {/* FILTER SECTION START */}
                           <hr/>
                            <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
                         <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Start Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" id="filter_start_date" value={filter_start_date} onChange={updatefilter_start_date}  />
                              <code>{filter_start_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">End Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control"  id="filter_end_date" value={filter_end_date} onChange={updatefilter_end_date}  />
                              <code>{filter_end_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Tr No.</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="12345"   id="filter_trno" value={filter_trno} onChange={updatefilter_trno}  />
                              <code>{filter_trno_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Employee_code</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="EMP0001" id="filter_employee_code" value={filter_employee_code} onChange={updatefilter_employee_code} />
                              <code>{filter_employee_code_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="Type" id="filter_type" value={filter_type} onChange={updatefilter_type} />
                            <code>{filter_type_er}</code>
                            </div>
                          </div>
                        </div>   
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">First Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="First Name" id="filter_first_name" value={filter_first_name} onChange={updatefilter_first_name} />
                              <code>{filter_first_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Last Name</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="Last Name" id="filter_last_name" value={filter_last_name} onChange={updatefilter_last_name}  />
                            <code>{filter_last_name_er}</code>
                            </div>
                          </div>
                        </div>   
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="myemail@gmail.com"  id="filter_email" value={filter_email} onChange={updatefilter_email} />
                              <code>{filter_email_er}</code> 
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="91 9000000000"  id="filter_contact" value={filter_contact} onChange={updatefilter_contact} />
                              <code>{filter_contact_er}</code>
                            </div>
                          </div>
                        </div>                     
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Salary Status</label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}}  id="filter_salary_status" value={filter_salary_status} onChange={updatefilter_salary_status}>
                              <option value=" ">all</option>
                              <option value="advance">advance</option>
                              <option value="due">due</option>
                              <option value="payment">payment</option>
                              </select>
                              <code>{filter_salary_status_er}</code>
                            </div>
                          </div>
                        </div>
                      {/*}  <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control"  id="filter_amount" placeholder="10000.00" value={filter_amount} onChange={updatefilter_amount} />
                              <code>{filter_amount_er}</code>
                            </div>
                          </div>
                        </div>  */}
                        <div class="col-md-8">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Amount</label>
                            <div class="col-sm-4">
                              <select class="form-control" style={{padding:"1rem"}} id="filter_amount_in_sign" value={filter_amount_sign} onChange={updatefilter_amount_sign}  >
                              <option className="dropdown-item" value=" ">All</option>
                              <option className="dropdown-item" value="equals">equals</option>
                              <option className="dropdown-item" value="more than" >more than</option>
                              <option className="dropdown-item" value="less than">less than</option>
                              <option className="dropdown-item" value="more than or equals" >more than or equals</option>
                              <option className="dropdown-item" value="less than or equals" >less than or equals</option>
                              </select>
                              <code>{filter_amount_sign_er}</code>
                            </div>
                            <div class="col-sm-4">
                              <input type="text" class="form-control" placeholder="5000.00" id="filter_amount" value={filter_amount} onChange={updatefilter_amount}   />
                              <code>{filter_amount_er}</code>
                            </div>
                          </div>
                        </div>                    
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Mode</label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}}  id="filter_mode" value={filter_mode} onChange={updatefilter_mode}>
                              <option value=" ">all</option>
                              <option value="cash">cash</option>
                              <option value="bank">bank</option>
                              </select>
                              <code>{filter_mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Select Bank</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Select Bank" style={{padding:"1rem"}} id="filter_bank_id" value={filter_bank_id} onChange={updatefilter_bank_id}>
                              <option value=" ">Select Bank</option>
                              {
                              Tbanks.map((curElm2,ind)=>{

                              return(
                              <>
                              <option value={curElm2.Bank_id}>{curElm2.Bank_name}</option>
                              </>
                              )
                              }
	 				   
	                         		)
                              }
                              </select>
                              <code>{filter_bank_id_er}</code>
                            </div>
                          </div>
                        </div>                      
                        <div class="col-md-4">
                         <button class="btn btn-primary" onClick={()=>{ setfilter_val(1); getData(); }}>Apply Filters</button>
                         <button class="btn btn-danger" style={{marginLeft:"1rem"}} onClick={()=>{ setfilter_val(0); getData(); }}>Remove Filters</button>
                        </div>
                        <br/><br/>
                      </div>
                            <hr/>                      
                            </div>
                            
                            {/* FILTER SECTION END */}


                        <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                       
                          <div class="dropdown">
                            <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>

                            <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button>     

                            <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton1">
                              <h6 class="dropdown-header">Columns</h6>
                              <hr/>
                              
                              {/* Column 1 */}
                              <li><div class="d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Sn</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c1_yes" onClick={()=>{setcd_col1_val(1); document.getElementById("cd_c1_yes").style.display="none"; document.getElementById("cd_c1_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c1_no" style={{ display:"none"}} onClick={()=>{ setcd_col1_val(0); document.getElementById("cd_c1_yes").style.display="block"; document.getElementById("cd_c1_no").style.display="none"; }}></i>
                              </div></div></li> 
                               {/* Column 2 */}
                               <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Date</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c2_yes"  onClick={()=>{setcd_col2_val(1); document.getElementById("cd_c2_yes").style.display="none"; document.getElementById("cd_c2_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c2_no" style={{ display:"none"}} onClick={()=>{ setcd_col2_val(0); document.getElementById("cd_c2_yes").style.display="block"; document.getElementById("cd_c2_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 3 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Tr_no</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c3_yes"  onClick={()=>{setcd_col3_val(1); document.getElementById("cd_c3_yes").style.display="none"; document.getElementById("cd_c3_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c3_no" style={{ display:"none"}} onClick={()=>{ setcd_col3_val(0); document.getElementById("cd_c3_yes").style.display="block"; document.getElementById("cd_c3_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 4 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Employee Id</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c4_yes"  onClick={()=>{setcd_col4_val(1); document.getElementById("cd_c4_yes").style.display="none"; document.getElementById("cd_c4_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c4_no" style={{ display:"none"}} onClick={()=>{ setcd_col4_val(0); document.getElementById("cd_c4_yes").style.display="block"; document.getElementById("cd_c4_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 5 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Employee Code</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c5_yes"  onClick={()=>{setcd_col5_val(1); document.getElementById("cd_c5_yes").style.display="none"; document.getElementById("cd_c5_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c5_no" style={{ display:"none"}} onClick={()=>{ setcd_col5_val(0); document.getElementById("cd_c5_yes").style.display="block"; document.getElementById("cd_c5_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 6 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">First Name</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c6_yes"  onClick={()=>{setcd_col6_val(1); document.getElementById("cd_c6_yes").style.display="none"; document.getElementById("cd_c6_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c6_no" style={{ display:"none"}} onClick={()=>{ setcd_col6_val(0); document.getElementById("cd_c6_yes").style.display="block"; document.getElementById("cd_c6_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 7 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Last Name</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c7_yes" onClick={()=>{setcd_col7_val(1); document.getElementById("cd_c7_yes").style.display="none"; document.getElementById("cd_c7_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c7_no" style={{ display:"none"}} onClick={()=>{ setcd_col7_val(0); document.getElementById("cd_c7_yes").style.display="block"; document.getElementById("cd_c7_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 8 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Email</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c8_yes" onClick={()=>{setcd_col8_val(1); document.getElementById("cd_c8_yes").style.display="none"; document.getElementById("cd_c8_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c8_no" style={{ display:"none"}} onClick={()=>{ setcd_col8_val(0); document.getElementById("cd_c8_yes").style.display="block"; document.getElementById("cd_c8_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 9 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Contact</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c9_yes" onClick={()=>{setcd_col9_val(1); document.getElementById("cd_c9_yes").style.display="none"; document.getElementById("cd_c9_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c9_no" style={{ display:"none"}} onClick={()=>{ setcd_col9_val(0); document.getElementById("cd_c9_yes").style.display="block"; document.getElementById("cd_c9_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 10 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Type</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c10_yes" onClick={()=>{setcd_col10_val(1); document.getElementById("cd_c10_yes").style.display="none"; document.getElementById("cd_c10_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c10_no" style={{ display:"none"}} onClick={()=>{ setcd_col10_val(0); document.getElementById("cd_c10_yes").style.display="block"; document.getElementById("cd_c10_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 11 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Mode</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c11_yes" onClick={()=>{setcd_col11_val(1); document.getElementById("cd_c11_yes").style.display="none"; document.getElementById("cd_c11_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c11_no" style={{ display:"none"}} onClick={()=>{ setcd_col11_val(0); document.getElementById("cd_c11_yes").style.display="block"; document.getElementById("cd_c11_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 12 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Basic Salary</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c12_yes" onClick={()=>{setcd_col12_val(1); document.getElementById("cd_c12_yes").style.display="none"; document.getElementById("cd_c12_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c12_no" style={{ display:"none"}} onClick={()=>{ setcd_col12_val(0); document.getElementById("cd_c12_yes").style.display="block"; document.getElementById("cd_c12_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 13 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Incentives</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c13_yes" onClick={()=>{setcd_col13_val(1); document.getElementById("cd_c13_yes").style.display="none"; document.getElementById("cd_c13_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c13_no" style={{ display:"none"}} onClick={()=>{ setcd_col13_val(0); document.getElementById("cd_c13_yes").style.display="block"; document.getElementById("cd_c13_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 14 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Allowances
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c14_yes" onClick={()=>{setcd_col14_val(1); document.getElementById("cd_c14_yes").style.display="none"; document.getElementById("cd_c14_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c14_no" style={{ display:"none"}} onClick={()=>{ setcd_col14_val(0); document.getElementById("cd_c14_yes").style.display="block"; document.getElementById("cd_c14_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 15 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Provident Fund
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c15_yes" onClick={()=>{setcd_col15_val(1); document.getElementById("cd_c15_yes").style.display="none"; document.getElementById("cd_c15_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c15_no" style={{ display:"none"}} onClick={()=>{ setcd_col15_val(0); document.getElementById("cd_c15_yes").style.display="block"; document.getElementById("cd_c15_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 16 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Salary Deductions
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c16_yes" onClick={()=>{setcd_col16_val(1); document.getElementById("cd_c16_yes").style.display="none"; document.getElementById("cd_c16_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c16_no" style={{ display:"none"}} onClick={()=>{ setcd_col16_val(0); document.getElementById("cd_c16_yes").style.display="block"; document.getElementById("cd_c16_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 17 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Amount
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c17_yes" onClick={()=>{setcd_col17_val(1); document.getElementById("cd_c17_yes").style.display="none"; document.getElementById("cd_c17_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c17_no" style={{ display:"none"}} onClick={()=>{ setcd_col17_val(0); document.getElementById("cd_c17_yes").style.display="block"; document.getElementById("cd_c17_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 18 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Salary Status
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c18_yes" onClick={()=>{setcd_col18_val(1); document.getElementById("cd_c18_yes").style.display="none"; document.getElementById("cd_c18_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c18_no" style={{ display:"none"}} onClick={()=>{ setcd_col18_val(0); document.getElementById("cd_c18_yes").style.display="block"; document.getElementById("cd_c18_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 19 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Remarks
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c19_yes" onClick={()=>{setcd_col19_val(1); document.getElementById("cd_c19_yes").style.display="none"; document.getElementById("cd_c19_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c19_no" style={{ display:"none"}} onClick={()=>{ setcd_col19_val(0); document.getElementById("cd_c19_yes").style.display="block"; document.getElementById("cd_c19_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 20 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Account Number
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c20_yes" onClick={()=>{setcd_col20_val(1); document.getElementById("cd_c20_yes").style.display="none"; document.getElementById("cd_c20_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c20_no" style={{ display:"none"}} onClick={()=>{ setcd_col20_val(0); document.getElementById("cd_c20_yes").style.display="block"; document.getElementById("cd_c20_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 21 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Updated By
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c21_yes" onClick={()=>{setcd_col21_val(1); document.getElementById("cd_c21_yes").style.display="none"; document.getElementById("cd_c21_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c21_no" style={{ display:"none"}} onClick={()=>{ setcd_col21_val(0); document.getElementById("cd_c21_yes").style.display="block"; document.getElementById("cd_c21_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 22 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Updated At
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c22_yes" onClick={()=>{setcd_col22_val(1); document.getElementById("cd_c22_yes").style.display="none"; document.getElementById("cd_c22_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c22_no" style={{ display:"none"}} onClick={()=>{ setcd_col22_val(0); document.getElementById("cd_c22_yes").style.display="block"; document.getElementById("cd_c22_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 23 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10 text-warning">Edit
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c23_yes" onClick={()=>{setcd_col23_val(1); document.getElementById("cd_c23_yes").style.display="none"; document.getElementById("cd_c23_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c23_no" style={{ display:"none"}} onClick={()=>{ setcd_col23_val(0); document.getElementById("cd_c23_yes").style.display="block"; document.getElementById("cd_c23_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 24 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10 text-danger">Delete
                              </div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c24_yes" onClick={()=>{setcd_col24_val(1); document.getElementById("cd_c24_yes").style.display="none"; document.getElementById("cd_c24_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c24_no" style={{ display:"none"}} onClick={()=>{ setcd_col24_val(0); document.getElementById("cd_c24_yes").style.display="block"; document.getElementById("cd_c24_no").style.display="none"; }}></i>
                              </div></div></li> 


                            {/*}  <div class="dropdown-divider"></div>
                              <button class="btn btn-danger">Close</button>*/}
                            </div> 
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>


                    <div className="table-responsive" id="reports" ref={componentRef}>
                      <table className="table table-hover">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}} id="cd_c1" hidden={cd_col1_val==1}>Sn</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c2" hidden={cd_col2_val==1}>Date</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c3" hidden={cd_col3_val==1}>Tr_no</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c4" hidden={cd_col4_val==1}>Employee Id</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c5" hidden={cd_col5_val==1}>Employee Code</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c6" hidden={cd_col6_val==1}>First Name</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c7" hidden={cd_col7_val==1}>Last Name</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c8" hidden={cd_col8_val==1}>Email</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c9" hidden={cd_col9_val==1}>Contact</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c10" hidden={cd_col10_val==1}>Type</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c11" hidden={cd_col11_val==1}>Mode</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Basic Salary</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c13" hidden={cd_col13_val==1}>Incentives</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c14" hidden={cd_col14_val==1}>Allowances</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c15" hidden={cd_col15_val==1}>Provident Fund</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c16" hidden={cd_col16_val==1}>Salary Deductions</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c17" hidden={cd_col17_val==1}>Amount</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c18" hidden={cd_col18_val==1}>Salary Status</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c19" hidden={cd_col19_val==1}>Remarks</th>
                       {/*}     <th  style={{fontWeight:"bold"}} id="cd_c20" hidden={cd_col20_val==1}>Account Number</th> */}
                            <th  style={{fontWeight:"bold"}} id="cd_c21" hidden={cd_col21_val==1}>Updated By</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c22" hidden={cd_col22_val==1}>Updated At</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c23" hidden={cd_col23_val==1}></th>
                            <th  style={{fontWeight:"bold"}} id="cd_c24" hidden={cd_col24_val==1}></th>

                          </tr>
                        </thead>
                        <tbody>
                        {
                       data.map((curElm,ind)=>{

                        return(
                        <>
                            <tr key={curElm.Id}>
                            <td id="cd_co1"  hidden={cd_col1_val==1}>{curElm.Sn}</td>
                            <td id="cd_co2"  hidden={cd_col2_val==1}>{curElm.Date}</td>
                            <td id="cd_co3"  hidden={cd_col3_val==1}>{curElm.Tr_no}</td>
                            <td id="cd_co4"  hidden={cd_col4_val==1}>{curElm.Employee_id}</td> 
                            <td id="cd_co5"  hidden={cd_col5_val==1}>{curElm.Employee_code}</td>
                            <td id="cd_co6"  hidden={cd_col6_val==1}>{curElm.First_name}</td>
                            <td id="cd_co7"  hidden={cd_col7_val==1}>{curElm.Last_name}</td>
                            <td id="cd_co8"  hidden={cd_col8_val==1}>{curElm.Email}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Contact}</td>
                            <td  hidden={cd_col10_val==1}>{curElm.Type}</td>
                            <td id="cd_co11" hidden={cd_col11_val==1}>
                            <label class="badge badge-success" hidden={(curElm.Mode != "cash")}>{curElm.Mode}</label>
                            <label class="badge badge-primary" hidden={(curElm.Mode != "bank")}>{curElm.Mode} <span hidden={(curElm.Mode!="bank")}>({curElm.Bank_name})</span></label></td>
                          {/*}  <td id="cd_co11"  hidden={cd_col11_val==1}>{curElm.Mode}</td> */}
                            <td id="cd_co12"  hidden={cd_col12_val==1}>{curElm.Basic_salary}</td>
                            <td id="cd_co13"  hidden={cd_col13_val==1}>{curElm.Incentives}</td>
                            <td id="cd_co14"  hidden={cd_col14_val==1}>{curElm.Allowances}</td>
                            <td id="cd_co15"  hidden={cd_col15_val==1}>{curElm.Provident_fund}</td>
                            <td id="cd_co16"  hidden={cd_col16_val==1}>{curElm.Salary_deductions}</td>
                            <td id="cd_co17"  hidden={cd_col17_val==1}>{curElm.Amount}</td>
                          {/*}  <td id="cd_co18"  hidden={cd_col18_val==1}>{curElm.Salary_status}</td> */}
                            <td id="cd_co18" hidden={cd_col18_val==1}>
                            <label class="badge badge-warning" hidden={((curElm.Salary_status == "due")||(curElm.Salary_status == "payment"))}>{curElm.Salary_status}</label>
                            <label class="badge badge-info" hidden={((curElm.Salary_status == "advance")||(curElm.Salary_status == "due"))}>{curElm.Salary_status}</label>
                            <label class="badge badge-danger" hidden={((curElm.Salary_status == "advance")||(curElm.Salary_status == "payment"))}>{curElm.Salary_status}</label>
                            </td>
                            <td id="cd_co19"  hidden={cd_col19_val==1}>{curElm.Salary_remarks}</td>
                          {/*}  <td id="cd_co20"  hidden={cd_col20_val==1}>{curElm.Account_number}</td>*/}
                            <td id="cd_co21"  hidden={cd_col21_val==1}>{curElm.Updated_by}</td>
                            <td id="cd_co22"  hidden={cd_col22_val==1}>{curElm.Date_updated} ({curElm.Time_updated})</td>

                            <td id="cd_co23"  hidden={cd_col23_val==1}><i class="mdi mdi-pencil-box text-warning" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Edit Id and Redirect to Edit
                            sessionStorage.setItem("EditId00",curElm.Id);
                            sessionStorage.setItem("Trno00",curElm.Tr_no);
                            setedate(curElm.Date);
                            seteemployee_id(curElm.Employee_id);
                            seteemployee_code(curElm.Employee_code);
                            setefirst_name(curElm.First_name);
                            setelast_name(curElm.Last_name);
                            setetype(curElm.Type);
                            setecontact(curElm.Contact);
                            seteemail(curElm.Email);
                            setesalary_status(curElm.Salary_status);
                            setebasic_salary(curElm.Basic_salary);
                            seteincentives(curElm.Incentives);
                            seteallowances(curElm.Allowances);
                            seteprovident_fund(curElm.Provident_fund);
                            setesalary_deductions(curElm.Salary_deductions);
                            seteamount(curElm.Amount);
                            setemode(curElm.Mode);
                            setebank_id(curElm.Bank_id);
                            setesalary_remarks(curElm.Salary_remarks);
                     
                            document.getElementById('edit-form').style.display = 'block'; }}></i></td>
                            <td id="cd_co24"  hidden={cd_col24_val==1}><i class="mdi mdi-delete-forever text-danger" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Edit Id for Delete
                            sessionStorage.setItem("DEditId00",curElm.Id); sessionStorage.setItem("DTrno00",curElm.Tr_no); document.getElementById('delete-card').style.display = 'block'; }}></i></td>
                          </tr>
                          </>
                        )
                        }
					   
		                  	)
                        }
                          
                         
                        </tbody>
                      </table>
                    </div>
                    
                    {/* PAGINATION SECTION START */}
                    <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={downloadExcel}><i class="mdi mdi-file-excel text-dark"></i></button>
                    
                  </div>
                </div>
              </div>

            {/* CASH TRANSACTIONS TABLE SECTION END */}

            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Usersalary;